
import React from 'react';
import { cn } from '@/lib/utils';
import { componentStyles } from '@/styles/theme';

interface HeadingProps {
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  children?: React.ReactNode;
  className?: string;
  dangerouslySetInnerHTML?: {
    __html: string;
  };
}

export const Heading = ({ 
  level = 2, 
  children, 
  className,
  dangerouslySetInnerHTML,
  ...props 
}: HeadingProps) => {
  const Tag = `h${level}` as keyof JSX.IntrinsicElements;
  
  // Enhanced styling based on level with improved typography
  let baseStyle = '';
  
  if (level === 1) {
    baseStyle = "text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-white tracking-tight mb-6 pb-2";
  } else if (level === 2) {
    baseStyle = "text-xl sm:text-2xl md:text-3xl font-bold text-gray-100 tracking-tight leading-relaxed mb-5 mt-7";
  } else if (level === 3) {
    baseStyle = "text-lg sm:text-xl font-semibold text-gray-200 leading-relaxed mb-4 mt-6";
  } else {
    baseStyle = "text-base md:text-lg font-medium text-gray-300 mb-3 mt-4";
  }
  
  if (dangerouslySetInnerHTML) {
    return (
      <Tag 
        className={cn(baseStyle, className)} 
        dangerouslySetInnerHTML={dangerouslySetInnerHTML}
        {...props}
      />
    );
  }
  
  return (
    <Tag className={cn(baseStyle, className)} {...props}>
      {children}
    </Tag>
  );
};

export default Heading;
